import FirebaseService from "../services/impl/firebase/FirebaseService";
import {getCurrentEnv} from "./dbConfigs";
import faker from "faker";
import ICustomer, { newCustInstance } from "../types/ICustomer";
import { customRenderExample } from "../theme/@vuexy/autoComplete/AutoCompleteSourceCode";
import FirebaseCustomerService from "../services/impl/firebase/FirebaseCustomerService";
import IActivity, { newActivityInstance, IActivityActor, IActivityType, IActivityMeeting, IActivityContent } from "../types/IActivity";
import IDocument, { newDocInstance, IDocumentStatus } from "../types/IDocument";

const NO_OF_CUSTOMERS = 1;
const NO_OF_DOCUMENTS = 1;
const NO_OF_ANALYTICS = 3;
/**
 * Seed database will be constructed only in QA env,
 * The data will be "set" on every connection so subsequent runs will seed the EXACT same data
 */
const lookups: any =  {
    // 'DOC_CATEGORY': [
    //     {name: 'Private', value:'PRIVATE', description: 'Private Documents', isActive: true},
    //     {name: 'Public', value:'PUBLIC', description: 'Public Documents', isActive: true}
    // ],
    // 'DOC_TYPE': [
    //     {name: 'Pdf', value:'PDF', description: 'PDF Documents', isActive: true},
    //     {name: 'Doc', value:'DOC', description: 'Documents', isActive: true}
    // ],
    'LANGUAGES': [
        { name: 'English', value: 'en', description: '', isActive: true },
        { name: 'Hindi', value: 'hi', description: '', isActive: true },
        { name: 'Spanish', value: 'spa', description: '', isActive: true },
        { name: 'Italian', value: 'it', description: '', isActive: true },
        { name: 'Japanese', value: 'jpn', description: '', isActive: true },
    ]
 }

const roles = [
    {name: 'ADMIN', description: 'Documents (RWD), Users (RWD), meetings (RWDA), customers (RWDA)'},
    {name: 'CONTENT_AUTHOR', description: 'Documents (RWDA), meetings(RWDA->own), customers (RWDA)'},
    {name: 'SALES_USER', description: 'Documents (R), customers (R), meetings (RWDA'}
]

export default class SeedDB{
    firebase: FirebaseService;
    constructor(firebase: FirebaseService){
        this.firebase = firebase;
    }

    /*public migrateDB(){
        if(getCurrentEnv() === 'qa'){
            Object.keys(lookups).map((k:string)=>{
                this.firebase.lookupSetting(k).set(lookups[k])
            });

            this.firebase.roles().set(roles)

        }
        
    }*/

    public async generateFakeCustomerData(){
        if(getCurrentEnv() === 'qa'){
            /*for(var i=0;i< NO_OF_CUSTOMERS;i++){
                this.createOneCustomer(i);
            }
            for(var i=0;i<NO_OF_DOCUMENTS;i++)
                this.createOneDocument(i);
            */
            /*for(var i=0;i<NO_OF_ANALYTICS;i++)
                this.createOneAnalytics(i);
            */

           /*this.deleteAllCustomers();
           this.deleteAllActivities();
           this.deleteAllDocuments();
           */
           
        }
    }

    private async createOneAnalytics(i:number){
        let activity: IActivity = newActivityInstance();
        activity.activityType = ["CONTENT_SHARED", "CONTENT_VISITED", "MEETING_ATTENDED", "MEETING_INVITED"][this.getRandomInt(3)];
        if(activity.activityType === 'CONTENT_SHARED' || activity.activityType === 'CONTENT_VISITED'){
            activity.content = await this.getContentActivityObject(activity.activityType)
            activity.meeting = {} as IActivityMeeting;
        } else {
            activity.meeting = await this.getMeetingActivityObject(activity.activityType)
            activity.content = {} as IActivityContent;
        }
        
        activity.primaryActor= await this.getRandomActor()
        const secActor = await this.getRandomActor();
        activity.secondaryActors =  [secActor]
        activity.channel = 'WEB'
        activity.time = new Date().getTime()
        activity.customProperties = [];

        try{
            activity.uid = i+'';
            this.firebase.activities().doc().set(activity);
            //Create entry in customer
            this.firebase.customers().doc(activity.primaryActor.uid).collection('activities').doc().set({
                activityType: activity.activityType,
                channel: activity.channel,
                time: activity.time,
                content: activity.content,
                meeting: activity.meeting,
                secondaryActors: activity.secondaryActors,
                customProperties: activity.customProperties 
            });
            
            if(activity.activityType === 'CONTENT_SHARED' || activity.activityType === 'CONTENT_VISITED'){
                this.firebase.documents().doc(activity.content.uid).collection('activities').doc().set({
                    activityType: activity.activityType,
                    channel: activity.channel,
                    time: activity.time,
                    primaryActor: activity.primaryActor,
                    secondaryActors: activity.secondaryActors,
                    customProperties: activity.customProperties 
                })
            }
        }catch(e){
            debugger;
        }
    }

    private async getContentActivityObject(type:string):Promise<any>{
        let obj = {};
        const document:any = await this.getRandomDocument();
        obj = {
                uid: document.uid,
                title: document.name,
                duration: document.readTime
        }
        return obj;
    }
    private async getMeetingActivityObject(type:string):Promise<any>{
        const obj = {
                uid: '-1',
                title: faker.company.catchPhrase(),
                invitedOn: faker.date.recent().getTime(),
                duration: this.getRandomInt(30)
            }
        return obj;
    }

    private async getRandomActor():Promise<IActivityActor>{
        const customer:any = await this.getRandomCustomer();
        return {
            uid: customer.uid,
            name: customer.account.firstName +' '+ customer.account.lastName,
            imageUrl: customer.account.image,
            role: 'CUSTOMER'
        }
    }

    private async getRandomCustomer(){
        let customer:any = {};
        const i:number = this.getRandomInt(NO_OF_CUSTOMERS);
        const snapshot:any = await this.firebase.customers().orderBy('uid').startAt(i).limit(1).get();
        snapshot.forEach((child:any) => {
            customer = child.data();
            customer.uid = child.id;
        });
        return customer;
    }

    private async getRandomDocument(){
        let document:any = {};
        const i:number = this.getRandomInt(NO_OF_DOCUMENTS);
        const snapshot:any = await this.firebase.documents().orderBy('uid').startAt(i).limit(1).get();
        snapshot.forEach((child:any) => {
            document = child.data();
            document.uid = child.id;
        });
        return document;
    }


    private createOneDocument(index:number){
        let document:IDocument = newDocInstance();
        document.name = faker.commerce.productName()
        document.description = faker.lorem.paragraph()
        document.contentType = ['PUBLIC', 'PRIVATE'][this.getRandomInt(1)];
        document.category = ["PRESENTATION", "PDF"][this.getRandomInt(1)];
        document.customerStage = this.getRandomInt(5)+"";
        document.coverTemplate = 'none';
        document.isActive = true
        document.readTime = this.getRandomInt(10)
        document.shareable = true
        document.tags = faker.lorem.words().split(' ');

        document.file.fileName = faker.system.commonFileName('pdf');
        document.file.extension = 'pdf';
        document.file.conversionStatus = 'COMPLETED'
        document.file.docUrl = faker.image.image();
        document.file.mimeType = 'application/pdf';

        document.file.status = IDocumentStatus.Completed;
        
        const noOfPages = this.getRandomInt(20);
        document.file.noOfPages = noOfPages;
        let pages = [];
        for(var i=0;i<noOfPages;i++)
            pages[i] = {id: i, url:faker.image.imageUrl()};
        document.file.pages = pages;
        document.file.dimension = {width: 0, height: 0}
        document.file.size = this.getRandomInt(300);
        document.file.thumbPageNo = this.getRandomInt(noOfPages);
        document.file.thumbUrl = faker.image.image();
        
        document.who.createdOn = faker.date.past();
        document.who.owner = {
            uid: "fakeUserId",
            displayName: faker.name.findName(),
            imageUrl: faker.image.imageUrl()
        }

        try{
            document.uid = i+'';
            this.firebase.documents().doc().set(document);
        }catch(e){
            debugger;
        }
    }

    private createOneCustomer(i:number){
        let customer: ICustomer = newCustInstance();
             customer.account.firstName = faker.name.firstName();
             customer.account.lastName = faker.name.lastName();
             customer.account.company = faker.company.companyName();
             customer.account.email = faker.internet.email();
             customer.account.jobTitle = faker.name.jobTitle();
             customer.account.additionalInfo = faker.lorem.sentence();
             customer.account.title = faker.name.title();
             customer.account.phoneNumber = faker.phone.phoneNumber();
             customer.account.image = faker.image.image();
             customer.account.departmentName = faker.name.jobDescriptor();
             
             customer.address.address1 = faker.address.streetAddress();
             customer.address.address2 = faker.address.county();
             customer.address.city = faker.address.city();
             customer.address.state = faker.address.state();
             customer.address.pincode = faker.address.zipCode();
             customer.address.country = faker.address.country();

             customer.personalInfo.dob = faker.date.past();
             customer.personalInfo.website = faker.internet.url();

             customer.who.createdOn = faker.date.past();
             customer.lastActivity = new Date().getTime();
             customer.who.owner = {
                 uid: "fakeCustomerId",
                 displayName: faker.name.findName(),
                 imageUrl: faker.image.imageUrl()
             }
             try{
                 customer.uid = i+'';
                 this.firebase.customers().doc().set(customer);
             }catch(e){
                 debugger;
             }
    }

    private async deleteAllCustomers(){
        try{
           const snapshot = await this.firebase.customers().get()
           snapshot.forEach((data:any) => {
               const key = data.id;
               this.firebase.customers().doc(key).delete();
           })
        }catch(e){
            debugger;
        }
    }

    private async deleteAllDocuments(){
        try{
           const snapshot = await this.firebase.documents().get()
           snapshot.forEach((data:any) => {
               const key = data.id;
               this.firebase.documents().doc(key).delete();
           })
        }catch(e){
            debugger;
        }
    }

    private async deleteAllActivities(){
        try{
           const snapshot = await this.firebase.activities().get()
           snapshot.forEach((data:any) => {
               const key = data.id;
               this.firebase.activities().doc(key).delete();
           })
        }catch(e){
            debugger;
        }
    }

    private getRandomInt(max:number) {
        return Math.floor(Math.random() * Math.floor(max));
      }
}
